import * as React from 'react';
import * as styles from './TagItem.module.scss';
import clsx from 'clsx';

export const TagItem = ({
  children,
  isSelected,
  className,
  onClick,
}: {
  children: React.ReactNode;
  isSelected?: boolean;
  className?: string;
  onClick?(): void;
}) => (
  <button className={clsx(styles.tagItem, className, isSelected && styles.tagItem___selected)} onClick={onClick}>
    {children}
  </button>
);
